import {
  Message,
  BarChart,
  FormatListBulleted,
  Add,
  SmartToyOutlined,
  MoreVert,
  FormatShapes,
} from '@mui/icons-material';
import {
  BLOCKS_V2_URL,
  IHC_ANTIBODIES_EXTERNAL_URL,
  SAMPLE_EDITOR_URL,
  SLIDE_VIEWER_URL,
} from 'constants/urls';
import { ORDER_RESOURCE_NAME } from 'services/resources/apiConstants';

export const SLIDES_LIST_TAB = 'slidesList';
export const AI_TOOLS_TAB = 'aiTools';
export const ANNOTATIONS_TAB = 'extAnnotations';

export const actionTabs = {
  meta: 'Metadata',
  comments: 'Comments',
  slidesList: 'Slides List',
  groups: 'Groups',
  aiTools: 'AI Tools',
  extAnnotations: 'Annotations',
  actions: 'Actions',
};

export const TABS_EXCLUDED_FOR_MULTISELECT = [actionTabs[ANNOTATIONS_TAB]];

export const actionTabsIcons = {
  meta: <BarChart />,
  comments: <Message />,
  slidesList: <FormatListBulleted />,
  groups: <Add />,
  aiTools: <SmartToyOutlined />,
  // aiTools: <Grain />,
  extAnnotations: <FormatShapes />,
  actions: <MoreVert />,
};

export const getBlockLink = (blockUUID) =>
  blockUUID ? `${BLOCKS_V2_URL}?blockUUID=${blockUUID}` : '';

export const getAntibodyLink = (antibodyUUID) =>
  antibodyUUID
    ? IHC_ANTIBODIES_EXTERNAL_URL.replace(':antibodyUUID?', antibodyUUID)
    : '';

export const getSampleLink = (sampleId) =>
  sampleId ? `${SAMPLE_EDITOR_URL}?search=${sampleId}` : '';

export const getOrderLink = (orderId) =>
  orderId ? `/${ORDER_RESOURCE_NAME}${orderId}/slides` : '';

export const getSlideLink = (slideId) =>
  slideId ? SLIDE_VIEWER_URL.replace(':slideUUID', slideId) : '';

export const STAIN_TYPES = [
  {
    name: 'h_and_e',
    displayName: 'H&E',
  },
  {
    name: 'ihc',
    displayName: 'IHC',
  },
  {
    name: 'unstained',
    displayName: 'Unstained',
  },
  {
    name: 'special_stain',
    displayName: 'Special Stain',
  },
  { name: 'other', displayName: 'Other' },
];

export const FETCH_SPECIAL_STAINS_ERROR = 'Failed to fetch special stains';
export const UPDATE_SLIDE_METADATA_ERROR = 'Failed to update slide metadata';
export const DISPLAYED_METADATA_LABELS = {
  antibody: 'Antibody',
  stainType: 'Stain Type',
  specialStain: 'Special Stain',
  alias: 'Alias',
  name: 'Name',
};
export const BACKEND_METADATA_LABELS = {
  antibody: 'antibody',
  stainType: 'stain_type',
  specialStain: 'special_stain',
  alias: 'alias',
  name: 'name',
};
